import { Folder, Trash2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { memo } from 'react';
import { Button } from '@/app/components/ui/button';
import { normalizePath } from '../../../_utils';
import type { ClawFileItem } from '../../../types';
import { getItemName } from '../../File/utils';
import { ActionButton } from './ActionButton';

interface MediaFolderCardProps {
  item: ClawFileItem;
  deleting: boolean;
  onEnter: (item: ClawFileItem) => void;
  onDelete: (item: ClawFileItem) => void;
}

const MediaFolderCardBase = ({ item, deleting, onEnter, onDelete }: MediaFolderCardProps) => {
  const t = useTranslations();
  const path = normalizePath(item.path);

  return (
    <div className="rounded-12 border border-system-white08 bg-[rgba(255,255,255,0.04)] p-3 transition hover:bg-system-white08">
      <div className="flex items-center gap-3">
        <Button
          variant="text"
          className="h-auto min-w-0 flex-1 justify-start gap-3 whitespace-normal rounded-none p-0 text-left font-normal hover:bg-transparent"
          onClick={() => onEnter(item)}
        >
          <div className="flex size-9 shrink-0 items-center justify-center rounded-12 bg-system-white08 text-system-white40">
            <Folder className="size-4" />
          </div>
          <div className="flex min-w-0 flex-1 flex-col justify-center">
            <div className="truncate text-system-white text-xs">{getItemName(item)}</div>
            <div className="mt-0.5 break-all text-[10px] text-system-white24 leading-4">{path}</div>
          </div>
        </Button>
        <ActionButton
          tooltip={t('claw.assets.actions.delete')}
          icon={<Trash2 className="size-4" />}
          disabled={deleting}
          stopPropagation
          onClick={() => onDelete(item)}
        />
      </div>
    </div>
  );
};

export const MediaFolderCard = memo(MediaFolderCardBase);
